import React, { useState, useEffect } from "react";
import newsImage from "../../assets/year-7-science.jpg";
import sanityClient from "../../client";
import imageUrlBuilder from "@sanity/image-url";

const LatestNews = (props) => {
  const [news, setNews] = useState(null);

  const builder = imageUrlBuilder(sanityClient);
  const urlFor = (source) => {
    return builder.image(source);
  };

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "news"]|order(_createdAt desc)[0..2]{

            title,    
            mainImage{
                  asset->{
                    _id,
                    url
                  }
                },
          body
              }`
      )
      .then((data) => setNews(data))
      .catch(console.error);
  }, []);

  if (!news) return <div>Loading...</div>;
  return (
    <div className={props.className}>
      <img
        src={urlFor(news[props.item].mainImage).url()}
        alt=""
        className="h-56 w-full object-top object-cover"
      />
      <div className="h-44 w-full object-top object-cover bg-mark-blue p-8 overflow-hidden text-white ">
        <h1 className="text-4xl">{news[props.item].title}</h1>
        <p className="mt-2 text-ellipsis whitespace-nowrap overflow-hidden">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque
          voluptatum similique aspernatur nam sapiente pariatur molestiae cum at
          iusto ex voluptates doloremque dolore delectus autem quaerat illum
          vero, sint officiis.
        </p>
      </div>
    </div>
  );
};

export default LatestNews;
